import { ErrorHandler, Inject, Injectable, Injector } from '@angular/core';
import { ToastService } from './toast.service';
import { HttpErrorResponse } from '@angular/common/http';

import { AppLoggingService } from './app-logging.service';
import { environment } from 'src/environments/environment';
import { COMMON_ERROR_MESSAGES, RESET_ERROR_MESSAGES } from '../constants/error-message-constants';

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService implements ErrorHandler {

  constructor(
    @Inject(Injector) private injector: Injector,
    private appLoggingService: AppLoggingService
  ) {
  }

  private get toastService(): ToastService {
    return this.injector.get(ToastService);
  }

  handleError(error: Error | HttpErrorResponse) {
    if (error instanceof HttpErrorResponse) {

      const innerError = error.error.error;
      const errorsObject = error?.error?.result?.errors;
      const mergedArray = errorsObject ? ([] as any[]).concat(...Object.values(errorsObject)) : [];
      // This will block the toast message in admin module for 500 error because we have custom UI for 500 error
      const isInternalServerError = error.status === 500 && (innerError.message === COMMON_ERROR_MESSAGES.general || innerError.message === RESET_ERROR_MESSAGES.changesPassword || innerError.message.includes(RESET_ERROR_MESSAGES.resetCode));
      if (innerError?.details && !innerError.details.includes(RESET_ERROR_MESSAGES.resetCode)) {

        this.toastService.error(innerError.details);
      }
      else if (mergedArray.length > 0) {
        mergedArray.forEach(err =>this.toastService.error(err));
      }
      else {
        if (error.status === 404) {
          this.toastService.warning(innerError.message)
        } else if (!isInternalServerError) {
          this.toastService.error(innerError.message);
        }
      }
    } else {
      if (environment.envName === 'dev') console.log(error);
      this.appLoggingService.logTrace('ErrorHandlerService', error);
      this.appLoggingService.logException(error);
    }

  }
}
